import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { getLanguage, storeLanguage } from './utils'

const initialState: LocaleState = {
  availableLanguages: [
    { code: 'en' },
    { code: 'fi' },
    { code: 'sv' },
    { code: 'es' },
    { code: 'nb' },
    { code: 'da' },
    { code: 'pt' },
    { code: 'nl' },
    { code: 'fr' },
    { code: 'de' },
  ],
  language: {
    code: getLanguage(),
  },
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
}

const slice = createSlice({
  name: 'locale',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language.code = action.payload
      storeLanguage(action.payload)
    },
  },
})

export const selectLocale = (state: RootState): LocaleState => state.locale

export const { setLanguage } = slice.actions

export default slice.reducer
